// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af51207d","239":"a7dca826","553":"3c85836b"}[chunkId] + ".chunk.js";
};